enum FrequencyUnitTime {
  DIAS = "DIAS",
  SEMANAS = "SEMANAS",
  MESES = "MESES",
  ANOS = "ANOS",
  PERIODO_PAGO = "PERIODO_PAGO"
}

export { FrequencyUnitTime };